import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PulloverSelect } from 'vopay';
import styles from './PageSizeSelector.module.scss';

export type PageSize = '10' | '20' | '50' | '100' | 'all';

export type PageSizeSelectorProps = {
  totalNumResults?: number;
  value?: PageSize;
  onChange?: (value: PageSize) => void;
};

const PAGE_SIZES: Exclude<PageSize, 'all'>[] = ['10', '20', '50', '100'];

const PageSizeSelector: FC<PageSizeSelectorProps> = ({ totalNumResults = 0, value = '20', onChange = () => {} }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'UI.PageSizeSelector' });

  // Trans component cannot be used here: Trans internally clones elements from the
  // components array, which breaks reactivity on props like `value` and `onChange`.
  // The `|` split is intentional — it places the select between the two label halves.
  const [before, after] = t('showingEntries').split('|');

  return (
    <div className={styles.container}>
      <span className={styles.label}>{before}</span>

      <PulloverSelect value={value} onChange={onChange} align="start">
        {PAGE_SIZES.map((size) => (
          <PulloverSelect.Option key={size} value={size}>
            {size}
          </PulloverSelect.Option>
        ))}
        <PulloverSelect.Option value="all">
          {String(t('allOption', { total: totalNumResults.toLocaleString('en-US') }))}
        </PulloverSelect.Option>
      </PulloverSelect>

      {after && <span className={styles.label}>{after}</span>}
    </div>
  );
};

export default PageSizeSelector;
